/**
 * makeInitialSessionRuntime
 * -------------------------
 */
export function makeInitialSessionRuntime() {
    return {
        nextClientSeq: 1,
        lastServerSeqSeen: 0,
        lastKnownSessionId: null,
    };
}
/**
 * noteServerSeqSeen
 * -----------------
 *
 * Advances the runtime's last seen server sequence monotonically.
 */
export function noteServerSeqSeen(runtime, serverSeq) {
    return {
        ...runtime,
        lastServerSeqSeen: Math.max(runtime.lastServerSeqSeen, serverSeq),
    };
}
/**
 * noteSessionId
 * -------------
 *
 * Records the last known authenticated/resumed server session id.
 */
export function noteSessionId(runtime, sessionId) {
    return {
        ...runtime,
        lastKnownSessionId: sessionId,
    };
}
/**
 * clearSessionId
 * --------------
 *
 * Clears the currently known server session id.
 *
 * Useful when the controller decides the current session identity
 * should no longer be trusted.
 */
export function clearSessionId(runtime) {
    return {
        ...runtime,
        lastKnownSessionId: null,
    };
}
/**
 * allocateOutboundFrameMeta
 * -------------------------
 *
 * Allocates the next client outbound sequencing metadata and returns:
 * - updated runtime
 * - the base envelope metadata to pass into protocol frame builders
 *
 * Rules:
 * - seq increments monotonically
 * - ack reflects the latest server seq seen
 */
export function allocateOutboundFrameMeta(args) {
    const seq = args.runtime.nextClientSeq;
    return {
        runtime: {
            ...args.runtime,
            nextClientSeq: seq + 1,
        },
        meta: {
            v: args.protocolVersion,
            msgId: args.msgId,
            ts: args.now,
            seq,
            ack: args.runtime.lastServerSeqSeen,
        },
    };
}
/**
 * peekOutboundFrameMeta
 * --------------------
 *
 * Returns the current outbound envelope metadata without consuming/incrementing
 * the client sequence counter.
 *
 * Use this for pre-auth frames such as HELLO when the protocol defines that
 * they do not count for normal session sequencing.
 */
export function peekOutboundFrameMeta(args) {
    return {
        v: args.protocolVersion,
        msgId: args.msgId,
        ts: args.now,
        seq: args.runtime.nextClientSeq,
        ack: args.runtime.lastServerSeqSeen,
    };
}
